import Screen from "@components/molecules/BrowseImage/Screen";

export * from "@components/molecules/BrowseImage/types";

export default Screen;
